export const actionPerformedOptions = [
  'Administrative',
  'Driving',
  'Keys',
  'Packing/Unpacking',
  'Service Calls',
  'Special Event Prep',
  'Vehicle Servicing',
  'Vending Machine Prep',
  'Warehouse Management',
];

export const actionTypeOptionsMap = {
  Administrative: [
    'Meeting',
    'Monthly Inventory',
    'Responding to Emails',
    'RMA - Incoming Parts',
    'RMA - Outgoing Parts',
    'SAP Inventory',
    'Training',
  ],
  Driving: ['Courier', 'DOT Box Trucks', 'Equipment Delivery', 'Equipment Installation'],
  Keys: ['Filing', 'Ordering', 'Shipping Replacements'],
  'Packing/Unpacking': ['Consumables', 'Depot', 'Repairs', 'Vans'],
  'Vehicle Servicing': ['Inspection', 'Maintenance'],
  'Vending Machine Prep': ['OBT Cleaning', 'Paint and Sticker'],
  'Warehouse Management': [
    'Asset Tagging',
    'Organizing',
    'Packing',
    'Testing',
  ],
};
